/* ============================================================
 * custom-cart-feedback.js
 * "Add to cart" 点击成功特效
 *
 * 背景: 本店安装了 UpCart 购物车 app, 它会拦截加购表单的提交,
 *       主题自带的 block-buy-buttons 的 submit 处理器因此不会触发,
 *       无法在那里挂加购成功特效.
 * 方案: 用捕获阶段(capture)的委托点击监听, 抢在 UpCart 处理之前,
 *       给被点击的 "Add to cart" 按钮加上 .btn--added 成功特效(样式在 overrides.css).
 *       纯视觉反馈, 不改变、不干预实际加购逻辑.
 * 作用范围: 全站所有加购按钮 —— 包括:
 *       - quick-add 弹框内 ([data-tool-tip-content]) 的 Add to cart
 *       - 产品页主 Add to cart 按钮 (.add-to-cart / button[name="add"])
 * ============================================================ */
(function () {
  var ADDED_CLASS = 'btn--added';
  var ADDED_TEXT = 'Added to cart'; // 成功文案, 可按需改成 "已加入购物车"
  var DURATION = 2000; // 特效持续毫秒数, 之后自动复原

  function showAdded(btn) {
    if (!btn) return;
    // 已在特效中 / 不可用 / 正在加载, 则跳过
    if (btn.classList.contains(ADDED_CLASS)) return;
    if (btn.hasAttribute('disabled') || btn.getAttribute('aria-busy') === 'true') return;

    var span = btn.querySelector('span');
    var original = span ? span.textContent : null;

    btn.classList.add(ADDED_CLASS);
    if (span) span.textContent = ADDED_TEXT;

    setTimeout(function () {
      btn.classList.remove(ADDED_CLASS);
      if (span && original !== null) span.textContent = original;
    }, DURATION);
  }

  // 捕获阶段监听, 确保即使 UpCart 在冒泡阶段 stopPropagation 也能先收到
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      // 全站加购按钮: 产品页主按钮 + quick-add 弹框内按钮
      var btn = e.target.closest('button[name="add"], .add-to-cart');
      if (btn) showAdded(btn);
    },
    true
  );
})();
